module.exports = __webpack_public_path__ + "images/emoji/shower.bc5148550f6f6ea9d911.png";